import { gql } from 'graphql-request'

class BuzzlUserQueries {
  getBuzzlUsers = gql`
    query getBuzzlUsers($where: BuzzlUserWhereInput, $orderBy: BuzzlUserExtendedOrderByInput) {
      buzzlUsers(where: $where, orderBy: $orderBy) {
        id
        assignedCustomers {
          id
          name
        }
        role
        createdAt
        user {
          id
          displayName
          firstName
          lastName
          email
        }
      }
    }
  `
}

const buzzlUserQueries = new BuzzlUserQueries()

export default buzzlUserQueries
